import { getFrontLogger } from './loggers/FrontLogger';

export function redirectToRequestAccessPage() {
  getFrontLogger().info('Redirecting to REQUEST_ACCESS_PAGE');
  const unauthorizedUrl: string = window.sgmeConfiguration.unauthorizedUrl;
  window.location.replace(unauthorizedUrl);
}

export function getFakeSsoUserEmail() {
  if (window.sgmeConfiguration?.enableFakeSso) {
    const params = new URLSearchParams(self.location.search);
    const userEmail = params.get('fakeSSO');
    const overrideMailUser = sessionStorage.getItem('OverrideMailUser');
    return overrideMailUser ?? userEmail;
  }
}
